(function() {
  'use strict';

  angular
    .module('sempraWebapp')
    .filter('weekDaysFacilityFilter', weekDaysFacilityFilter);

  /** @ngInject */
  function weekDaysFacilityFilter($translate) {
    return function(text) {
      if(!text) return;
      switch (text) {
        case "Mon":
          return $translate.instant("MON");
        case "IlluminationMon":
          return $translate.instant("MON");
        case "VacuumsMon":
          return $translate.instant("MON");
        case "Tue":
          return $translate.instant("TUE");
        case "IlluminationTue":
          return $translate.instant("TUE");
        case "VacuumsTue":
          return $translate.instant("TUE");
        case "Wed":
          return $translate.instant("WED");
        case "IlluminationWed":
          return $translate.instant("WED");
        case "VacuumsWed":
          return $translate.instant("WED");
        case "Thu":
          return $translate.instant("THU");
        case "IlluminationThu":
          return $translate.instant("THU");
        case "VacuumsThu":
          return $translate.instant("THU");
        case "Fri":
          return $translate.instant("FRI");
        case "IlluminationFri":
          return $translate.instant("FRI");
        case "VacuumsFri":
          return $translate.instant("FRI");
        case "Sat":
          return $translate.instant("SAT");
        case "IlluminationSat":
          return $translate.instant("SAT");
        case "VacuumsSat":
          return $translate.instant("SAT");
        case "Sun":
          return $translate.instant("SUN");
        case "IlluminationSun":
          return $translate.instant("SUN");
        case "VacuumsSun":
          return $translate.instant("SUN");
        case "Hol":
          return $translate.instant("HOLIDAY");
        case "IlluminationHol":
          return $translate.instant("HOLIDAY");
        case "VacuumsHol":
          return $translate.instant("HOLIDAY");
        default:
          return text;
      }
    };
  }
})();
